import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconText = _resolveComponent("IconText")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        class: "hangover-gradient",
        elevation: "2",
        color: "purple",
        height: "80",
        floating: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_title, { class: "hover" }, {
            text: _withCtx(() => [
              _createVNode(_component_IconText)
            ]),
            _: 1
          }),
          _createVNode(_component_v_app_bar_nav_icon, {
            variant: "text",
            onClick: _withModifiers(_ctx.onDrawerClick, ["stop"])
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        modelValue: _ctx.drawer,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.drawer) = $event)),
        location: "right",
        temporary: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: item.value,
                  title: item.title,
                  to: { hash: item.value }
                }, null, 8, ["title", "to"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}